import React from 'react'
import { createBrowserHistory } from 'history'
import ButterToast, { POS_TOP, POS_RIGHT } from 'butter-toast'
import { Router, Route, Switch } from 'react-router-dom'
import { StateProvider } from '../state'
import { DetailsPage } from './DetailsPage'
import { OrderPage } from './OrderPage'
import { ReportPage } from './ReportPage'

export const history = createBrowserHistory()

export const AccessCodeManagementApp = ({ coursenum, resultsPerPage }) => {
  const initialState = {
    orders: [],
    order: {},
    codes: [],
    filters: {
      createDateLowerBound: '',
      createDateUpperBound: '',
      emailFilter: '',
      statusFilter: '',
      couponCodeFilter: '',
      institutionFilter: '',
    },
    projections: { royalties: '', commissions: '' },
    coursenum: coursenum,
    resultsPerPage: resultsPerPage,
    totalOrderCount: 0,
  }

  const reducer = (state, action) => {
    switch (action.type) {
      case 'updateOrders':
        return {
          ...state,
          orders: action.payload,
        }
      case 'updateOrderCount':
        return {
          ...state,
          totalOrderCount: action.payload,
        }
      case 'updateOrder':
        return {
          ...state,
          order: action.payload,
        }
      case 'updateCodes':
        return {
          ...state,
          codes: action.payload,
        }
      case 'updateOrderCodes':
        return {
          ...state,
          order: action.payload.order,
          codes: action.payload.codes,
        }
      case 'updateFilters':
        return {
          ...state,
          filters: action.payload,
        }
      case 'updateProjections':
        return {
          ...state,
          projections: {
            royalties: action.payload.royalties,
            commissions: action.payload.commissions,
          },
        }
      default:
        return { ...state }
    }
  }
  return (
    <StateProvider initialState={initialState} reducer={reducer}>
      <ButterToast
        position={{ vertical: POS_TOP, horizontal: POS_RIGHT }}
        style={{ top: '65px' }}
      />
      <Router history={history}>
        <Switch>
          <Route
            exact
            path="/account/admin_coupons.management/:coursenum/details/:orderId"
            component={DetailsPage}
          />
          <Route
            exact
            path="/account/admin_coupons.management/:coursenum/"
            component={OrderPage}
          />
          <Route
            path="/account/admin_coupons.management/:coursenum/reports/"
            component={ReportPage}
          />
        </Switch>
      </Router>
    </StateProvider>
  )
}
